import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authAxios, QueryStatus } from "../../../../../utils";
import { RootState } from "../../../../../redux/store";
import type {
  BulkUpdateVehicleContractDataResponse,
  ContractDataVehicle,
} from "./vehicleContractDataApi";

export type VehicleContractDataState = {
  importContractDataStatus: QueryStatus;
  updatedCount: number | null;
};

const initialState: VehicleContractDataState = {
  importContractDataStatus: "idle",
  updatedCount: null,
};

export const uploadVehicleContractDataAsync = createAsyncThunk(
  "vehicleContractData/upload",
  async (
    payload: { vehicles: ContractDataVehicle[]; companyUuid: string },
    thunkAPI,
  ) => {
    const company = (thunkAPI.getState() as RootState).home.company;
    const axiosInstance = authAxios({ companyUuid: company?.uuid });
    const { data } =
      await axiosInstance.post<BulkUpdateVehicleContractDataResponse>(
        "vehicles/contract_data",
        {
          companyUuid: payload.companyUuid,
          vehicles: payload.vehicles,
        },
      );
    return data.vehiclesUpdatedNb;
  },
);

export const vehicleContractDataSlice = createSlice({
  name: "vehicleContractData",
  initialState,
  reducers: {
    resetImportContractDataStatus(state) {
      state.importContractDataStatus = "idle";
      state.updatedCount = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadVehicleContractDataAsync.pending, (state) => {
        state.importContractDataStatus = "processing";
      })
      .addCase(uploadVehicleContractDataAsync.fulfilled, (state, action) => {
        state.importContractDataStatus = "success";
        state.updatedCount = action.payload;
      })
      .addCase(uploadVehicleContractDataAsync.rejected, (state) => {
        state.importContractDataStatus = "failed";
      });
  },
});

export const { resetImportContractDataStatus } =
  vehicleContractDataSlice.actions;

export const selectImportContractDataStatus = (state: RootState) =>
  state.vehicleContractData.importContractDataStatus;

export const selectUpdatedCount = (state: RootState) =>
  state.vehicleContractData.updatedCount;

export default vehicleContractDataSlice.reducer;
